import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchRolesApi } from 'api/roles-api';
import toast from 'react-hot-toast';
import { getErrorString } from 'utils';

const initialState = {
  activeColumns: [],
  roles: [],
  pagination: {},
  loading: true,
  pending: false,
};

export const fetchRolesListing = createAsyncThunk('fetch/roles', async (updatedParamsObject = {}) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchRolesApi(paramsObj, '');
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const RolesSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    setRolesLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setRolesActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchRolesListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchRolesListing.fulfilled, (state, action) => {
        if (state.loading) {
          //means first time loading
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.roles = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchRolesListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setRolesLoading, setRolesActiveColumn } = RolesSlice.actions;
export default RolesSlice.reducer;
